<template>
  <section class="cta" :class="class">
    <div class="py-12 px-4 sm:px-16 mx-auto">
      <div class="max-w-screen-md mx-auto md:text-center">
        <h4 class="font-extrabold text-xl md:text-3xl pb-6">{{ title }}</h4>
        <p class="text-base md:text-lg text-dark dark:text-zinc-300">
          {{ text }}
        </p>
        <iframe
          :data-tally-src="formLink"
          loading="eager"
          width="100%"
          height="1"
          frameborder="0"
          marginheight="0"
          marginwidth="0"
          :title="title"
        ></iframe>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
interface Props {
  title: string;
  text: string;
  class?: string;
  formId?: string;
}
const props = defineProps<Props>();
const formLink = computed(() => {
  return `https://tally.so/embed/${props.formId}?transparentBackground=1&dynamicHeight=1&hideTitle=1`;
});
onMounted(() => {
  try {
    Tally?.loadEmbeds();
  } catch (error) {
    console.error(error);
  }
});
</script>

<style scoped></style>
